import {mediaQueryBreakpointMD} from "../Utils/Utils";

const Menu1 = () => {

	const handleMouseOver = (e) => {
		const menuItem = e.currentTarget.parentNode;
		const subMenu = menuItem.querySelector('.sub-menu');

		if(window.innerWidth >= mediaQueryBreakpointMD) {
			if(window.innerWidth >= mediaQueryBreakpointMD) {
				menuItem.classList.add('js-mouseover');
				if(subMenu) {
					menuItem.classList.add('js-reveal-sub-menu');
				}
			}
		}
	};
	const handleMouseLeave = (e) => {
		const menuItem = e.currentTarget;
		menuItem.classList.remove('js-mouseover');
		menuItem.classList.remove('js-reveal-sub-menu');
	}

	document.querySelectorAll('#menu-1 .menu > .menu-item > a').forEach((menuItemLink) => {
		menuItemLink.addEventListener('mouseover', handleMouseOver);

		const menuItem = menuItemLink.parentNode;
		menuItem.addEventListener('mouseleave', handleMouseLeave);
	});
};

export default Menu1;